export default vm => {
  console.log(vm); //vue的this对象
  return {
    index: false,
    align: 'center',
    headerAlign: 'center',
    // height: 'auto',
    calcHeight: 20,
    // labelWidth: 130,
    header: false, // 控制操作按钮
    border: true,
    stripe: true,
    editBtn: false,
    delBtn: false,
    tip: false,
    menu: true, // 表格操作栏
    column: [
      {
        label: '虚拟事件ID',
        prop: 'id'
      },
      {
        label: '虚拟事件名称',
        prop: 'name',
        slot: true
      },
      {
        label: '所含原始事件',
        prop: 'event_names',
      },
      {
        label: '创建时间',
        prop: 'create_time'
      }
    ]
  };
};
